import { CALL_API } from "admin/middlewares/api";

export const ADD_USER_FOR_AUTHENTICATION_REQUEST =
  "ADD_USER_FOR_AUTHENTICATION_REQUEST";
export const ADD_USER_FOR_AUTHENTICATION_SUCCESS =
  "ADD_USER_FOR_AUTHENTICATION_SUCCESS";
export const ADD_USER_FOR_AUTHENTICATION_ERROR =
  "ADD_USER_FOR_AUTHENTICATION_ERROR";

export function post_user_authentication(
  username,
  password,
  confirmPassword,
  givenName,
  surname,
) {
  return (dispatch) => {
    if (password === confirmPassword)
      dispatch(
        post_user_authentication_call(username, password, givenName, surname),
      );
    else
      dispatch({
        type: ADD_USER_FOR_AUTHENTICATION_ERROR,
        error: "Passwords do not match",
      });
  };
}

function post_user_authentication_call(username, password, givenName, surname) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/users/staff/create-person",
      authenticatedRequest: true,
      data: { username, password, givenName, surname },
      method: "POST",
      types: [
        ADD_USER_FOR_AUTHENTICATION_REQUEST,
        ADD_USER_FOR_AUTHENTICATION_SUCCESS,
        ADD_USER_FOR_AUTHENTICATION_ERROR,
      ],
    },
  };
}

export const ADD_USER_CLAIM_REQUEST = "ADD_USER_CLAIM_REQUEST";
export const ADD_USER_CLAIM_SUCCESS = "ADD_USER_CLAIM_SUCCESS";
export const ADD_USER_CLAIM_ERROR = "ADD_USER_CLAIM_ERROR";

export function post_user_add_claim(Identity, Role) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/users/staff/AddRole",
      authenticatedRequest: true,
      data: { PersonId: Identity, Role },
      method: "POST",
      types: [
        ADD_USER_CLAIM_REQUEST,
        ADD_USER_CLAIM_SUCCESS,
        ADD_USER_CLAIM_ERROR,
      ],
    },
  };
}

export const GET_USER_AUTHENTICATION_KEY_REQUEST =
  "GET_USER_AUTHENTICATION_KEY_REQUEST";
export const GET_USER_AUTHENTICATION_KEY_SUCCESS =
  "GET_USER_AUTHENTICATION_KEY_SUCCESS";
export const GET_USER_AUTHENTICATION_KEY_ERROR =
  "GET_USER_AUTHENTICATION_KEY_ERROR";

export function get_user_authentication_key(username) {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/users/staff/ga-registration-key?username=" + username,
      authenticatedRequest: true,
      data: { username },
      method: "GET",
      types: [
        GET_USER_AUTHENTICATION_KEY_REQUEST,
        GET_USER_AUTHENTICATION_KEY_SUCCESS,
        GET_USER_AUTHENTICATION_KEY_ERROR,
      ],
    },
  };
}

export const GET_USER_AUTHENTICATION_QR_REQUEST =
  "GET_USER_AUTHENTICATION_QR_REQUEST";
export const GET_USER_AUTHENTICATION_QR_SUCCESS =
  "GET_USER_AUTHENTICATION_QR_SUCCESS";
export const GET_USER_AUTHENTICATION_QR_ERROR =
  "GET_USER_AUTHENTICATION_QR_ERROR";

export function get_user_authentication_qr(username) {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/users/staff/ga-registration-qr?username=" + username,
      authenticatedRequest: true,
      data: { username },
      method: "GET",
      types: [
        GET_USER_AUTHENTICATION_QR_REQUEST,
        GET_USER_AUTHENTICATION_QR_SUCCESS,
        GET_USER_AUTHENTICATION_QR_ERROR,
      ],
    },
  };
}

export const POST_USER_SIGN_IN_AUTHENTICATE = "POST_USER_SIGN_IN_AUTHENTICATE";
export const POST_USER_SIGN_IN_SUCCESS = "POST_USER_SIGN_IN_SUCCESS";
export const POST_USER_SIGN_IN_ERROR = "POST_USER_SIGN_IN_ERROR";

export function post_user_sign_in_authenticate(Username, Password, Pin) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/auth/identity/authenticate",
      authenticatedRequest: true,
      data: { Username, Password, Pin },
      method: "POST",
      types: [
        POST_USER_SIGN_IN_AUTHENTICATE,
        POST_USER_SIGN_IN_SUCCESS,
        POST_USER_SIGN_IN_ERROR,
      ],
    },
  };
}

export const GET_USER_IDENTITY_REQUEST = "GET_USER_IDENTITY_REQUEST";
export const GET_USER_IDENTITY_SUCCESS = "GET_USER_IDENTITY_SUCCESS";
export const GET_USER_IDENTITY_ERROR = "GET_USER_IDENTITY_ERROR";

export function get_user_identity(username) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/users/staff/person-id?username=" + username,
      authenticatedRequest: true,
      data: { username },
      method: "GET",
      types: [
        GET_USER_IDENTITY_REQUEST,
        GET_USER_IDENTITY_SUCCESS,
        GET_USER_IDENTITY_ERROR,
      ],
    },
  };
}

export const POST_USER_PASSWORD_CHANGE_REQUEST =
  "POST_USER_PASSWORD_CHANGE_REQUEST";
export const POST_USER_PASSWORD_CHANGE_SUCCESS =
  "POST_USER_PASSWORD_CHANGE_SUCCESS";
export const POST_USER_PASSWORD_CHANGE_ERROR =
  "POST_USER_PASSWORD_CHANGE_ERROR";

export function post_user_change_password(Username, Password) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/users/staff/change-password",
      authenticatedRequest: true,
      data: { Username, Password },
      method: "POST",
      types: [
        POST_USER_PASSWORD_CHANGE_REQUEST,
        POST_USER_PASSWORD_CHANGE_SUCCESS,
        POST_USER_PASSWORD_CHANGE_ERROR,
      ],
    },
  };
}
